import styled from 'styled-components';

export const Page = styled.div`
  padding: 5px;
  height: calc(100vh - 98px);
  text-align: center;
  display: flex;
  background-color: var(--primary-color-sefaz);
  align-items: center;
  justify-content: center;
`;

export const PageTexto = styled.div`
  padding: 5px;
  padding-bottom: 80px;
  text-align: center;
  display: inline-table;
  width: 40%;
  background-color: var(--primary-color-sefaz);

  .link {
    color: #ffffff;
    border-bottom: 1px solid #ffffff;
    display: initial;
    cursor: pointer;
  }
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: center;

  button {
    margin: 5px;
  }

  .ant-btn {
    background-color: #ffffff;
    color: var(--primary-color-sefaz);
    height: 60px;
    font-weight: 600;
    width: 250px;
  }
`;

export const Imagem = styled.img`
  width: 55vw;
  height: 100%;
  @media (max-width: 800px) {
    display: none;
  }
`;

export const ImagemLogo = styled.img`
  font-family: 'Roboto', 'Open Sans', 'sans-serif', serif;
  width: 250px;
  margin: 60px;
`;

export const Subtitulo = styled.p`
  font-size: 25pt;
  font-weight: 500;
  padding: 0 0 10px 0;
  color: #ffffff;
  margin-bottom: 0;
  margin-top: -21px;
`;
